module.exports = __webpack_public_path__ + "5a81088986a2f074308dbfbe3c3a628d.svg";